// Topnavhome.js
import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import {
    Navbar, Nav, Collapse, NavbarBrand, Row, Col,
    NavbarToggler, UncontrolledDropdown, DropdownItem, DropdownToggle, DropdownMenu,
    NavItem
} from 'reactstrap';
import { publicRoutes, dropdowns } from '../../data/publicRoutes.data';
import IntlMessages from '../../helpers/IntlMessages';
import Ricon from '../../public-routes/homepage/Icon';
import { servicesData } from '../../data/services';

const TopNav = (props) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [MaiMenuOpen, setMainMenuOpen] = useState(false);
    const [leftColumnVisible, setLeftColumnVisible] = useState(false);
    const [rightColumnVisible, setRightColumnVisible] = useState(false);
    const [showLeftMenuLinks, setShowLeftMenuLinks] = useState(false);
    const [showRightMenuLinks, setShowRightMenuLinks] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const [selectedServiceData, setSelectedServiceData] = useState(null);
    const [openDropdownId, setOpenDropdownId] = useState(null);

    // Left side links - Main Services
    const leftMenuLinks = [
        { id: 'seo', path: '/services/seo', label: 'SEO' },
        { id: 'paid-media', path: '/services/paid-media', label: 'Paid Media' },
        { id: 'Strategy', path: '/services/startegy', label: 'Strategy & Data-AI' },
        { id: 'Branding', path: '/services/branding', label: 'Branding' }
    ];

    // Add scroll event listener
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleMenu = () => {
        if (!isMenuOpen) {
            // Opening menu
            setIsMenuOpen(true);
            setMainMenuOpen(true);
            setSelectedService(null);
            setSelectedServiceData(null);
            setOpenDropdownId(null);
            setTimeout(() => setLeftColumnVisible(true), 100);
            setTimeout(() => setRightColumnVisible(true), 100);

            // Show left menu links with delay
            setTimeout(() => setShowLeftMenuLinks(true), 1000);
            // Show right menu links with slight delay for staggered effect
            setTimeout(() => setShowRightMenuLinks(true), 1000);
        } else {
            // Closing menu
            setRightColumnVisible(false);
            setShowLeftMenuLinks(false);
            setShowRightMenuLinks(false);
            setSelectedService(null);
            setSelectedServiceData(null);
            setOpenDropdownId(null);
            setTimeout(() => setLeftColumnVisible(false), 100);
            setTimeout(() => setIsMenuOpen(false), 100);
            setTimeout(() => setMainMenuOpen(false), 1000);
        }
    };

    const handleLinkClick = () => {
        if (isMenuOpen) {
            setRightColumnVisible(false);
            setShowLeftMenuLinks(false);
            setShowRightMenuLinks(false);
            setSelectedService(null);
            setSelectedServiceData(null);
            setOpenDropdownId(null);
            setTimeout(() => setLeftColumnVisible(false), 100);
            setTimeout(() => {
                setIsMenuOpen(false);
            }, 400);
        }
    };

    const handleServiceClick = (service) => {
        // Find the full service data from servicesData
        const serviceData = servicesData.sidebarItems.find(
            s => s.id === service.id
        );
        setSelectedService(service);
        setSelectedServiceData(serviceData);
    };

    const handleSubServiceClick = () => {
        // Close menu when sub-service is clicked
        if (isMenuOpen) {
            setRightColumnVisible(false);
            setShowLeftMenuLinks(false);
            setShowRightMenuLinks(false);
            setSelectedService(null);
            setSelectedServiceData(null);
            setOpenDropdownId(null);
            setTimeout(() => setLeftColumnVisible(false), 100);
            setTimeout(() => {
                setIsMenuOpen(false);
            }, 400);
        }
    };

    const toggleDropdown = (serviceId) => {
        if (openDropdownId === serviceId) {
            setOpenDropdownId(null);
        } else {
            setOpenDropdownId(serviceId);
        }
    };

    // Close menu on escape key
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && isMenuOpen) {
                toggleMenu();
            }
        };

        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
            document.addEventListener('keydown', handleEscape);
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isMenuOpen]);

    return (
        <>
            <Navbar
                fixed='top'
                className={`bg-dark services navbar-island fixed-top d-flex ${isScrolled ? 'bg-dark navbar-scrolled' : ''}`}
                color="light"
                light
                expand="sm"
            >
                <NavbarBrand tag={Link} to="/" className="mr-3 navbar-brand-island">
                    <Ricon />
                </NavbarBrand>
                <Link
                    to='/'
                    className='logo-text mr-auto'
                >
                    ReachTix
                </Link>



                <div
                    className={`hamburger  hamburger--spin ${isMenuOpen ? 'is-active' : ''}`}
                    type="button"
                    onClick={toggleMenu}
                    aria-label="Menu"
                    aria-controls="fullscreen-menu"
                    aria-expanded={isMenuOpen}
                >
                    <span className="hamburger-box">
                        <span className="hamburger-inner"></span>
                    </span>
                </div>

                <div className="d-none ml-auto header-icons align-middle">
                    {Object.keys(dropdowns).map((dropdownKey) => {
                        const dropdown = dropdowns[dropdownKey];
                        return (
                            <div key={dropdownKey} className="mx-3 position-relative d-none d-md-inline-block">
                                <NavLink className="px-3 btn btn-outline-primary ml-2" to="/register">
                                    <IntlMessages id="register" />
                                    <i className="fas fa-user-circle mx-2"></i>
                                </NavLink>
                            </div>
                        );
                    })}
                    <div className="mx-3 position-relative d-none d-md-inline-block">
                        <NavLink className="px-3 btn btn-outline-primary ml-2" to="/login">
                            <span className="button-text">
                                <IntlMessages id="login" />
                            </span>
                            <i className="fas fa-sign-in-alt mx-2"></i>
                        </NavLink>
                    </div>
                </div>
            </Navbar>

            {/* Full Screen Menu Overlay */}
            <div className={isMenuOpen ? " Menu opened fixed inset-0 size-full" : "d-flex Menu fixed inset-0 z-0 text-secondary theme-astronomy"}>
                <div className={`spinner-container ${isMenuOpen ? 'open' : 'close'}`}>
                    <div className="square-spinner">
                        <span>
                            <em></em>
                        </span>
                    </div>
                    <div className="reverse-spinner">
                        <span>
                            <em></em>
                        </span>
                    </div>
                </div>


                {isMenuOpen && (
                    <div className={`menu-content-wrapper ${showLeftMenuLinks ? 'visible' : ''}`}>
                        <Row className="menu-links-row g-0">
                            {/* Left Column - Main Services */}
                            <Col md={6} className="left-column">
                                <div className="menu-section-left">
                                    {/* Main Services Title */}
                                    <div className="menu-section-title" style={{
                                        opacity: showLeftMenuLinks ? 1 : 0,
                                        transform: showLeftMenuLinks ? 'translateY(0)' : 'translateY(30px)',
                                        transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
                                        transitionDelay: '0.1s'
                                    }}>
                                        <h1 className='text-white'>Our Services</h1>
                                    </div>

                                    <div className="menu-links-container">
                                        {/* Left Menu Links - Main Services */}
                                        {leftMenuLinks.map((link, index) => {
                                            const serviceData = servicesData.sidebarItems.find(s => s.id === link.id);
                                            const hasSubItems = serviceData && serviceData.subItems && serviceData.subItems.length > 0;

                                            return (
                                                <div
                                                    key={link.id}
                                                    className="menu-link-wrapper"
                                                    style={{
                                                        opacity: showLeftMenuLinks ? 1 : 0,
                                                        transform: showLeftMenuLinks ? 'translateY(0)' : 'translateY(50px)',
                                                        transition: `all 0.7s cubic-bezier(0.16, 1, 0.3, 1)`,
                                                        transitionDelay: `${0.2 + (index * 0.08)}s`
                                                    }}
                                                >
                                                    {/* Desktop View - Click to show subs in right column */}
                                                    <div
                                                        className={`menu-link slide-up-link d-none d-md-block ${selectedService?.id === link.id ? 'active' : ''}`}
                                                        onClick={() => handleServiceClick(link)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <span className="menu-link-text">{link.label}</span>
                                                        {hasSubItems && <i className="fas fa-chevron-right ml-2" style={{ fontSize: '12px' }}></i>}
                                                    </div>

                                                    {/* Mobile View - Dropdown for subs */}
                                                    <div className="d-block d-md-none">
                                                        <div
                                                            className={`menu-link slide-up-link ${openDropdownId === link.id ? 'active' : ''}`}
                                                            onClick={() => hasSubItems && toggleDropdown(link.id)}
                                                            style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                                        >
                                                            <span className="menu-link-text">{link.label}</span>
                                                            {hasSubItems && (
                                                                <i className={`fas fa-chevron-${openDropdownId === link.id ? 'up' : 'down'} ml-2`} style={{ fontSize: '12px' }}></i>
                                                            )}
                                                        </div>

                                                        {/* Dropdown Sub-items for Mobile */}
                                                        {hasSubItems && openDropdownId === link.id && (
                                                            <div className="mobile-submenu pl-4 mt-2" style={{
                                                                animation: 'fadeIn 0.3s ease-in-out'
                                                            }}>
                                                                {serviceData.subItems.map((subItem, subIndex) => (
                                                                    <Link
                                                                        key={subItem.name}
                                                                        to={subItem.path}
                                                                        className="menu-link slide-up-link d-block"
                                                                        onClick={handleSubServiceClick}
                                                                        style={{
                                                                            padding: '12px 0',
                                                                            fontSize: '0.9rem',
                                                                            opacity: showLeftMenuLinks ? 1 : 0,
                                                                            transform: showLeftMenuLinks ? 'translateY(0)' : 'translateY(20px)',
                                                                            transition: `all 0.5s cubic-bezier(0.16, 1, 0.3, 1)`,
                                                                            transitionDelay: `${0.4 + (subIndex * 0.05)}s`
                                                                        }}
                                                                    >
                                                                        <span className="menu-link-text">{subItem.name}</span>
                                                                    </Link>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </Col>

                            {/* Right Column - Sub Services (shown when a service is selected on desktop) */}
                            <Col md={6} className="right-column d-none d-md-flex">
                                <div className="menu-section-right">
                                    {selectedServiceData && selectedServiceData.subItems && selectedServiceData.subItems.length > 0 ? (
                                        <>
                                            <div className="menu-section-title" style={{
                                                opacity: showRightMenuLinks ? 1 : 0,
                                                transform: showRightMenuLinks ? 'translateY(0)' : 'translateY(30px)',
                                                transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
                                                transitionDelay: '0.1s'
                                            }}>
                                                <h1 className='text-white'>{selectedService.label} Sub-services</h1>
                                            </div>
                                            <div className="menu-links-container">
                                                {selectedServiceData.subItems.map((subItem, index) => (
                                                    <div
                                                        key={subItem.name}
                                                        className="menu-link-wrapper"
                                                        style={{
                                                            opacity: showRightMenuLinks ? 1 : 0,
                                                            transform: showRightMenuLinks ? 'translateY(0)' : 'translateY(50px)',
                                                            transition: `all 0.7s cubic-bezier(0.16, 1, 0.3, 1)`,
                                                            transitionDelay: `${0.3 + (index * 0.08)}s`
                                                        }}
                                                    >
                                                        <Link
                                                            to={subItem.path}
                                                            className="menu-link slide-up-link"
                                                            onClick={handleSubServiceClick}
                                                        >
                                                            <span className="menu-link-text">{subItem.name}</span>
                                                        </Link>
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    ) : selectedService ? (
                                        <div className="menu-section-title" style={{
                                            opacity: showRightMenuLinks ? 1 : 0,
                                            transform: showRightMenuLinks ? 'translateY(0)' : 'translateY(30px)',
                                            transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
                                            transitionDelay: '0.1s'
                                        }}>
                                            <h1 className='text-white'>No sub-services available</h1>
                                        </div>
                                    ) : (
                                        <div className="menu-section-title" style={{
                                            opacity: showRightMenuLinks ? 1 : 0,
                                            transform: showRightMenuLinks ? 'translateY(0)' : 'translateY(30px)',
                                            transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
                                            transitionDelay: '0.1s'
                                        }}>
                                            <h1 className='text-white'>Select a service</h1>
                                            <p className="text-white-50 mt-3">Click on any service from the left to view its sub-services</p>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </div>
                )}
            </div>

            <style jsx>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                .mobile-submenu {
                    border-left: 2px solid rgba(255, 255, 255, 0.2);
                    margin-left: 10px;
                    padding-left: 20px;
                }
                
                @media (max-width: 767px) {
                    .menu-link-text {
                        font-size: 1rem;
                    }
                }
            `}</style>
        </>
    );
};

export default TopNav;